import { canonicalPhoneNumber } from '@ngsos/portal-core/incidents';

import { NgCopyButton } from '@/ui';

export type ContactRowProps = {
  name: string | null;
  phoneNumber: string | null;
};

export function ContactRow({ name, phoneNumber }: ContactRowProps) {
  const dialableNumber = phoneNumber?.trim() ?? '';
  const parsed = canonicalPhoneNumber(dialableNumber);

  return (
    <div className="d-flex justify-content-between align-items-center gap-2">
      <div className="medium">{name ?? ''}</div>

      {dialableNumber !== '' && (
        <div className="d-flex align-items-center medium flex-shrink-0">
          <div className="text-nowrap">
            <a href={parsed?.getUrlForCall() ?? `tel:${dialableNumber}`}>
              {parsed?.toFormattedString() ?? dialableNumber}
            </a>
          </div>

          <NgCopyButton valueToCopy={dialableNumber} cssClass="p-1" />
        </div>
      )}
    </div>
  );
}
